import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext, forwardRef, useImperativeHandle, useRef  } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { IconButton,   } from '@mui/material';
import { CcActionButton } from "../commonComponents/styledTexts";
import {ExclamationCircleIcon } from '@heroicons/react/20/solid'


import axios from 'axios';

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputNumber, InputText, InputURL, FileSelector, InputPercentage} from '../commonComponents/inputFields'


import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaOfferBroker, webPageSettingsValidationSchemaMemoryCards } from '../components/helperErrors'
import { ccColorTeal, ccColorDarkTeal, getRandomReadableBgColor } from '../components/helpersStyles';
import { lionIcons } from '../components/helpersIcons';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { RandomInt } from '../components/helpers';

const bgColors = ['#f5d1d2', '#e0d09f', '#c3f2ba', '#d4b1e2', '#c9cfe9']

const StackedBar = ({ data, height = "h-6", showLabels = true }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  if (total === 0) {
    return <div className={`${height} bg-gray-200 rounded-md`} />;
  }

  return (
    <div className={`flex w-full ${height} bg-gray-200 rounded-md overflow-hidden`}>
      {data.map((item, index) => {
        const percentage = (item.value / total) * 100;

        return (
          <div
            key={index}
            className="flex items-center justify-center text-ccColorDarkTeal text-xs whitespace-nowrap transition-all duration-300"
            style={{
              width: `${percentage}%`,
              backgroundColor: item.color,
            }}
          >
            {showLabels && percentage > 0 && (
              <span className='font-semibold'>{Math.round(percentage)}%</span>
            )}
          </div>
        );
      })}
    </div>
  );
};


export function OfferBrokerConfigurator(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState({ images: [{imgB64: '', href: ''}]})

const getColor = (index) => {
    if (index < bgColors.length) return bgColors[index]
    else return getRandomReadableBgColor()

}

  useEffect(() => {
    if (props.snippetInfo) {
      //console.log(props.snippetInfo)
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
    }
    else {
      
    }
  }, [props.templateId, props.snippetInfo, settings])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 26,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;
    result.href = props.snippetInfo.href;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }

  const handleOfferChange = (index, propName, propValue) => {
    const newImages = [...snippetSettings.images]
    const newImg = {...newImages[index], [propName]: propValue}
    newImages.splice(index, 1, newImg)

    const newSnippetSettings = {...snippetSettings, images: newImages }
    //console.log(newSnippetSettings)
    setSnippetSettings(newSnippetSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

  }
  const handleToggleIsLocked = (index) => {
    const toggledValue = !snippetSettings.images[index].isLocked
    handleOfferChange(index, 'isLocked', toggledValue)
  }

const handleOfferWeightChange = (index, weight) => {
    const newImages = [...snippetSettings.images]
    const increment = newImages[index].weight - weight //this is either +1 or -1

    const nonLockedImages = []
    let nonLockedImagesTotalWeight = 0
    for (let i=0; i<newImages.length; i+=1) {
        const img = newImages[i]
        if (!img.isLocked && i !== index) {
            nonLockedImages.push(img)
            nonLockedImagesTotalWeight += img.weight
        }
    }
    //check if it is possible otherwise to nothing
    //if increment = -1 then we need to have at least one nonLockedImages with weight > 0
    let updatePossible = true
    if (increment === -1) {
      if (nonLockedImages.filter(i => i.weight > 0).length === 0) updatePossible = false
    }

    if (updatePossible) {
      const newImg = {...newImages[index], weight: weight}
      newImages.splice(index, 1, newImg)

      //console.log(nonLockedImagesTotalWeight)

      if (nonLockedImages.length === 1) nonLockedImages[0].weight += increment
      else {
          if (increment === -1) {
            const nonLockedImagesPositiveWeight = nonLockedImages.filter(i => i.weight > 0)

            const randomIndex = RandomInt(0, nonLockedImagesPositiveWeight.length-1)
            nonLockedImagesPositiveWeight[randomIndex].weight += increment

          }
          else {
            const randomIndex = RandomInt(0, nonLockedImages.length-1)
            nonLockedImages[randomIndex].weight += increment
          }
      }
    }

    /* this code would be good if we had increment >1%, but here we always move by 1% increment so we can't spread
    const newTotal = 100 - weight
    if (nonLockedImages.length === 1) nonLockedImages[0].weight = newTotal
    else {
        let oldTotal = 0
        for (const img of nonLockedImages) oldTotal += img.weight
        const ratio = newTotal / oldTotal

        let partialTotal = 0
        for (let i=0; i<nonLockedImages.length; i+=1) {
            const img = nonLockedImages[i]
            console.log(img)
            if (i<nonLockedImages.length-1) {
                const updatedWeight = Math.floor(img.weight * ratio)
                img.weight = updatedWeight
                partialTotal += updatedWeight
            }
            else {
                img.weight = newTotal - partialTotal
            }
            
        }
    }
    */

    //simple logic
    const newSnippetSettings = {...snippetSettings, images: newImages }
    //console.log(newSnippetSettings)
    setSnippetSettings(newSnippetSettings)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}

const handleAddImage = () => {
  const newImages = [...snippetSettings.images]
  
  newImages.push({imgB64: '', href: '', weight: 0, bgColor: getColor(newImages.length), isLocked: false})

  const newSnippetSettings = {...snippetSettings, images: newImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))
}

const handleRemoveImage = (index) => {
  //after removing we need to spread the removed percentage across the other offers
  const newImages = [...snippetSettings.images]
  const removedPercentage = snippetSettings.images[index].weight
  newImages.splice(index, 1)
  const newImagesNonLocked = newImages.filter(i => !i.isLocked)
  const removedPercentagePerOffer = Math.floor(removedPercentage / newImagesNonLocked.length)
  for (let i=0; i<newImagesNonLocked.length; i+=1) {
    if (i === newImagesNonLocked.length-1) newImagesNonLocked[i].weight += (removedPercentage - removedPercentagePerOffer*i)
    else newImagesNonLocked[i].weight += removedPercentagePerOffer
  }

  //re-assiging colors
  for (let i=0; i< newImages.length; i+=1) {
    newImages[i].bgColor = getColor(i)
  }

  const newSnippetSettings = {...snippetSettings, images: newImages }
  setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

}
const canLock = () => {
    //check to see if there are at least 3 not locked offers
    //if so you can show the lock button
    return snippetSettings.images.filter(img => !img.isLocked).length >= 3
}
const handleEqualise = () => {
    const newImages = [...snippetSettings.images]
    const nonLockedImages = newImages.filter(i => !i.isLocked)

    let nonLockedImagesTotalWeight = 0
    for (let i=0; i<nonLockedImages.length; i+=1) {
      nonLockedImagesTotalWeight += nonLockedImages[i].weight
    }

    const equalisedAmount = Math.floor(nonLockedImagesTotalWeight / nonLockedImages.length)
    for (let i=0; i<nonLockedImages.length; i+=1) {
      if (i === nonLockedImages.length-1) {
        nonLockedImages[i].weight = (nonLockedImagesTotalWeight - equalisedAmount*i)
      }
      else nonLockedImages[i].weight = equalisedAmount
    }

  //console.log(nonLockedImages)
  //console.log(newImages)
  const newSnippetSettings = {...snippetSettings, images: newImages }
  //setSnippetSettings(newSnippetSettings)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

}

  return <div className='text-ccColorDarkTeal p-2 flex flex-col'>
    <div className='flex flex-row gap-x-4'>
      <div className="w-96">
        <InputText
                displayName="Name"
                value={snippetName}
                onChange={(val) => {handleSnippetNameChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetName')}
        />
      </div>

      <div className="w-96">
        <InputText
                  displayName="Description"
                  value={snippetDesc}
                  onChange={(val) => {handleSnippetDescChange(val);}}
                  error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
        />
      </div>
    </div>

    <div className='mt-2 font-poppins'>
        <div className='text-lg font-semibold'>Offers allocation</div>
        <div className=''>Must total 100%. Changing a value will redistribute the remaining percentages</div>
        
        <div className='flex flex-row items-center gap-x-2 mt-2'>
          <div className='w-[600px]'>
            <StackedBar data={snippetSettings.images.map(i => {return {value: i.weight, color: i.bgColor}})} />
          </div>
          <button className='border border-ccColorDarkTeal rounded text-sm px-2 py-1 font-semibold hover:bg-ccColorTeal hover:text-white'
              onClick={handleEqualise}
          >Equalise</button>
        </div>
        <div className='flex flex-col gap-y-6'>
            {snippetSettings.images.map((c, index) => <>
                <div className='flex flex-row gap-x-4 items-center'>
                    <div>
                        <div className='flex flex-row items-center gap-x-4'>
                            <FileSelector noDeleteButton
                            text="Upload image"
                            onChange={(dataUrl) => handleOfferChange(index, 'imgB64', dataUrl)}
                            />
                            <div>
                                {c.imgB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
                                    <Iconify icon="carbon:no-image" width={200} />
                                    <div className='font-poppins font-semibold'>No image uploaded</div>
                                </div>

                                }
                                {c.imgB64 !== '' &&
                                <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex justify-center'>
                                    <div className='relative h-full' >

                                        <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${c.imgB64}`} />

                                    </div>
                                </div>
                                }
                                {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index) && getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index).length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1 mb-8'>
                                    <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

                                    {getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsImages', index)}
                                    </div>
                                }

                            </div>
                        </div>
                        <div className='flex flex-col -mt-2'>
                            <div className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                                Href
                            </div>
                            <InputURL
                                value={c.href}
                                onChange={(val) => handleOfferChange(index, 'href', val)}
                                error={getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsHrefs', index)}
                                />
                        </div>
                    </div>
                    <div className='flex flex-row items-center gap-x-1'>
                        <InputPercentage value={c.weight} min={0} max={100}
                            bgColor={c.bgColor}
                            onChange={(val) => handleOfferWeightChange(index, val)}
                        />
                        {(c.isLocked || canLock()) &&
                                <IconButton 
                                    onClick={() => handleToggleIsLocked(index)}
                                ><Iconify icon={c.isLocked ? lionIcons.Icon_Actions_LockOn : lionIcons.Icon_Actions_LockOff} className='text-ccColorDarkTeal' width={36} /></IconButton>
                        }
                        {!canLock() && <div className='text-gray-200'>{lionIcons.Icon_Actions_LockForbidden}</div>}
                    </div>

                    {snippetSettings.images.length > 2 && !props.isEdit &&
                      <div>
                          <IconButton 
                              onClick={() => handleRemoveImage(index)}
                          ><Iconify icon={lionIcons.Icon_Actions_Cancel} width={36} /></IconButton>
                      </div>
                    }

                </div>
            </>)
            }
        </div>

    </div>

      {!props.isEdit &&
        <CcActionButton className="w-fit mt-4"
          onClick={handleAddImage}
        >Add another image</CcActionButton>
      }

    </div>

}


export default function OfferBrokerWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();


    const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', href: '',
                  snippetSettings: {images: [{imgB64: '', href: '', weight: 50, bgColor: bgColors[0], isLocked: false}, {imgB64: '', href: '', weight: 50, bgColor: bgColors[1], isLocked: false}],  }});


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [resetStats, setResetStats] = useState(false); //only used when updating a tag
    const [isEdit, setIsEdit] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);

    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
        setIsEdit(true)
      }
      else setIsEdit(false)
    }, [props.snippetId])

    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);

        const newSnippetData = response.data;
        newSnippetData.snippetSettings = JSON.parse(response.data.snippetSettings);
        //console.log(newSnippetData.snippetSettings)
        //adding new metadata for compatibility with old tags that don't have it
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

  const submitDataSnippet = async () => {

    setShowLoader(true);
    setSuccessHtmlMsg('');
  
    try {
        let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/26`;
        if (params.snippetId !== null && params.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/26/${params.snippetId}`;

        const snippetSettingsToPost = {...snippetData.snippetSettings}

        //console.log(snippetSettingsToPost)
        const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetSettingsToPost),
                            resetStats: resetStats
                            }

        const response = await axios.post(url, dataToPost);
  
        setSuccessHtmlMsg(response.data);
        setShowSuccessMsg(true);
    } catch (error) {
      setShowSuccessMsg(false);
      setShowErrorMsg(true);
      console.log(error);
    }
    setShowLoader(false);
    setSubmitted(true)

    return true;
  }
  const handleElementChange = (snippetInfo) => {
    //console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaOfferBroker.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      setCurrentStep(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {
      //apply validation first
      //we can use the same validation of the image optimiser
      try {
        //console.log(snippetData)
        snippetDataValidationSchemaOfferBroker.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        //legacy issue: yup can return also href errors that we don't validate anymore
        // in this step. We need to supress this error here
        const hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'snippetSettingsRevealHref');
        if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
        
        
        //console.log(errorList)
        setActiveErrorList(errorList)
        if (errorList.length > 0) return false;
      }    
      

      //if we are here then the validastion is passed
      setCurrentStep(navInfo.nextIndex);
      submitDataSnippet()
      
    }
  }
    
    const handleClose = () => {
        navigate("/ph/offerBroker")
    }
    

    return <div>
        <CcStepper2
            steps={[{ name: 'Configure', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <OfferBrokerConfigurator
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
                                    isEdit={isEdit}
              />}

            {currentStep === 1 && <div className='flex flex-col items-center'>
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <div className='py-12'><CcLoader size={96} /></div> }
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 1 &&
                    <StepperNavButtons totalSteps={2}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}